import { ArrowUp } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#f5f5f7] py-14">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-8">
          <div className="flex items-center gap-3">
            <img src="/vontrail-logo.png" alt="VONTRAIL GROWTH logo" className="h-9 w-9 rounded-[9px] object-cover" />
            <div>
              <span className="block font-semibold tracking-tight text-[15px] text-[#1d1d1f]">
                VONTRAIL GROWTH
              </span>
              <p className="text-xs text-[#86868b]" data-testid="footer-tagline">
                Content built around your goals.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-8">
            <nav className="flex gap-6">
              {[
                { label: "Manifesto", href: "#manifesto" },
                { label: "System", href: "#services" },
                { label: "Who", href: "#who" },
              ].map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  className="text-xs text-[#6e6e73] hover:text-[#1d1d1f] transition-colors duration-200"
                >
                  {l.label}
                </a>
              ))}
            </nav>
            <a
              href="#top"
              data-testid="footer-back-to-top"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-[#6e6e73] hover:text-[#1d1d1f] transition-colors duration-200"
              aria-label="Back to top"
            >
              <ArrowUp className="h-4 w-4" />
            </a>
          </div>
        </div>
        <div className="mt-10 flex flex-col sm:flex-row justify-between gap-3 border-t border-black/[0.06] pt-6">
          <span className="text-xs text-[#86868b]">
            Copyright © {new Date().getFullYear()} VONTRAIL GROWTH. All rights reserved.
          </span>
          <a
            href="mailto:hello@vontrail.com"
            data-testid="footer-email"
            className="text-sm sm:text-base font-medium text-[#1d1d1f] hover:underline underline-offset-4 transition-colors duration-200"
          >
            Contact: hello@vontrail.com
          </a>
          <span className="text-xs text-[#86868b]">From idea to upload.</span>
        </div>
      </div>
    </footer>
  );
}
